<template>
    <v-card :elevation="this.elevation">
        <!-- CustomDataTable.vueから修正
        [:hide-default-header="this.hideHeader"]⇒[hide-default-header]
        -->
        <v-data-table :headers="this.header" :items="this.items"
        hide-default-header hide-default-footer :mobile-breakpoint="this.mobileWith"
        :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event" disable-sort
        :loading="loading" loading-text="データ取得中" :search="search">
            <!-- CustomDataTable.vueから削除
            <template slot="top">
                <v-toolbar flat>
                    <v-toolbar-title>{{this.tableName}}</v-toolbar-title>
                    <v-col lg="2">
                        <v-select v-show="this.visibleSelect" class="mt-5 ml-5" :items="this.selectItems" item-text="name" item-value="id" :label="this.selectLabel" @change="selectedHandler" no-data-text="データがありません" dense return-object/>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-text-field class="mr-2" v-show="this.filter" v-model="search" prepend-icon="mdi-card-search-outline" :label="this.filterLabel" single-line hide-details></v-text-field>
                    <slot name="button"></slot>
                    <v-btn v-show="this.visibleStore" depressed small @click.stop="storedHandler" color="success" :disabled="this.disableStore">新規作成</v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <slot name="custom"></slot>
            </template>
            -->
            <!-- CustomDataTable2.vueとして追加 -->
            <template v-slot:header="{ props: { headers } }">
              <thead>
              <tr>
                <th v-for="header in headers" :key="header.value">
                  <div>
                    {{ header.text }}
                  </div>
                  <v-divider v-if="header.bottomText" />
                  <div v-if="header.bottomText">
                    {{ header.bottomText }}
                  </div>
                </th>
              </tr>
              </thead>
            </template>
            <template v-slot:item="{ item, headers }">
              <tr>
                <td v-for="header in headers" :key="header.value">
                  <div v-if="header.value=='action_worker_content'">
                    <slot name="action_worker_content" v-bind:item="item"></slot>
                  </div>
                  <div v-if="header.value=='action'">
                    <slot name="action" v-bind:item="item"></slot>
                  </div>
                  <div v-if="header.value=='action_sub'">
                    <slot name="action_sub" v-bind:item="item"></slot>
                  </div>
                  <div v-else>
                    <div>
                      {{ item[header.value] }}
                    </div>
                    <v-divider v-if="header.bottomValue" />
                    <div v-if="header.bottomValue">
                      {{ item[header.bottomValue] }}
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            <!-- CustomDataTable.vueから削除
            <template v-slot:[`item.revision`]="{ item }">
                <slot name="revision" v-bind:item="item"></slot>
            </template>
            <template v-slot:[`item.status`]="{ item }">
                <slot name="status" v-bind:item="item"></slot>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <slot name="action" v-bind:item="item"></slot>
            </template>
            <template v-slot:[`item.move`]="{ item }">
                <slot name="move" v-bind:item="item"></slot>
            </template>
            -->
            <template v-slot:no-data>データがありません</template>
            <template v-slot:no-results>検索結果がありません</template>
        </v-data-table>
        <v-divider></v-divider>
        <v-card-actions v-if="pageCount >= 2">
            <v-pagination color="accent" v-model="page" :length="pageCount" :total-visible="7" prev-icon="mdi-menu-left" next-icon="mdi-menu-right"></v-pagination>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "CustomDataTable",
    props: {
        elevation: {
            type: Number,
            default: 1
        },
        // CustomDataTable.vueから削除
        // tableName: {
        //     type: String,
        //     required: true
        // },
        header: {
            type: Array,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        pagination: {
            type: Object,
            default: () => ({
                page: 1,
                pageCount: 0,
                itemsPerPage: 10,
            })
        },
        visibleStore: {
            type: Boolean,
            default: true
        },
        disableStore: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            required: false
        },
        filter: {
            type: Boolean,
            default: false
        },
        filterLabel: {
            type: String,
            default: "検索"
        },
        visibleSelect: {
            type: Boolean,
            default: false
        },
        selectLabel: {
            type: String,
            default: ""
        },
        selectItems: {
            type: Array,
            default: () => []
        },
    },
    data: () => ({
        search: '',
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        mobileWith: 1200
    }),
    created() {
        this.page = this.pagination.page;
        this.pageCount = this.pagination.pageCount;
        this.itemsPerPage = this.pagination.itemsPerPage;
    },
    watch: {
        pageCount () { this.resetPage(); },
    },
    methods: {
        resetPage () {
            if (this.pageCount < this.page) {
                this.page--;
            }
        },
        storedHandler (item) {
            this.$emit("stored", item);
        },
        selectedHandler (item) {
            this.$emit("selected", item);
        }
    }
};
</script>
<!-- CustomDataTable2.vueとして追加 -->
<style lang="scss" scoped>
  .v-data-table thead tr th {
    background-color: #0f6eb2;
  }
  .v-data-table thead tr th div {
    color: white;
    margin: 5px 0px;
  }
</style>
